// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CyisH","type":"styles_type__3kNhS","choices":"styles_choices__3VJ8_"};